import { render, staticRenderFns } from "./PreparationAttachmentViewer.vue?vue&type=template&id=6637fd1a&"
import script from "./PreparationAttachmentViewer.vue?vue&type=script&lang=js&"
export * from "./PreparationAttachmentViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports